<template>
  <div class="wapper">
    <el-container style="100%">
      <el-main style="background: #fff">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form
                :inline="true"
                ref="form"
                :model="searchForm"
                class="demo-form-inline"
            >
              <div class="uers-left">
                <el-form-item label="后台端：">
                  <el-tag type="primary">{{ this.url }}</el-tag>
                </el-form-item>
                <el-form-item label="手机端：">
                  <el-tag type="primary">{{ this.url1 }}</el-tag>
                </el-form-item>
                <br/>
                <el-form-item label="搜索：">
                  <el-input
                      v-model="searchForm.name"
                      placeholder="名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.phone"
                      placeholder="手机"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input
                      v-model="searchForm.userName"
                      placeholder="账号"
                  ></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-select
                      placeholder="注册类型："
                      clearable
                      v-model="searchForm.documentTypeId"
                      class="el-input-position"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option
                        v-for="(item, index) in DocumentType"
                        :key="index"
                        :label="item.name"
                        :value="item.documentTypeId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label>
                  <el-select
                      placeholder="注册通道："
                      clearable
                      v-model="searchForm.registerId"
                      class="el-input-position"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option
                        v-for="(item, index) in registers"
                        :key="index"
                        :label="item.name"
                        :value="item.registerId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label>
                  <el-select placeholder="禁用：" v-model="searchForm.disabled">
                    <el-option value="-1" label="全部"></el-option>
                    <el-option value="0" label="未禁用"></el-option>
                    <el-option value="1" label="已禁用"></el-option>
                  </el-select>
                </el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click="searchSubmit()"
                >搜索
                </el-button
                >
                &nbsp;&nbsp;&nbsp;
                <el-button
                    type="primary"
                    icon="el-icon-export"
                    @click="exportExcel()"
                >导出
                </el-button
                >
              </div>
              <div class="uers-right">
                <span class="btn-r">
                  <el-button
                      type="primary"
                      plain
                      icon="el-icon-plus"
                      @click="addSubmit"
                  >新增</el-button
                  >
                </span>
                <el-popover
                    placement="bottom"
                    title="批量导入"
                    width="220"
                    trigger="click"
                >
                  <div>
                    <el-upload
                        class="upload-demo"
                        :action="action"
                        :auto-upload="false"
                        :on-change="uploadChange"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    >
                      <el-button size="small" type="primary"
                      >选择导入模板
                      </el-button>
                    </el-upload>
                    <el-button
                        type="success"
                        @click="download"
                        plain
                        icon="el-icon-download"
                        class="down-template"
                    >下载模板
                    </el-button
                    >
                  </div>
                  <p class="import-text">只能选择 .xls .xlsx 文件</p>
                  <div>
                    <el-button type="success" @click="importData"
                    >批量添加
                    </el-button
                    >
                    <el-button type="success" @click="importModifyData"
                    >批量修改
                    </el-button>
                  </div>
                  <el-button
                      type="primary"
                      plain
                      icon="el-icon-upload2"
                      slot="reference"
                  >导入
                  </el-button
                  >
                </el-popover
                >&nbsp;&nbsp;&nbsp;
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                height="100%"
                border
                class="tabbox"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                @selection-change="handleSelectionChange"
            >
              <el-table-column
                  type="selection"
                  width="55"
                  align="center"
              ></el-table-column>
              <el-table-column prop="name" label="团组名" align="center">
                <template slot-scope="scope">
                  团组名称：<span>{{ scope.row.name }}</span><br/>
                  类型名称：<span>{{ scope.row.typeName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="phone" label="手机" align="center">
                <template slot-scope="scope">
                  手机号：<span>{{ scope.row.phone }}</span><br/>
                  邀请码：<span>{{ scope.row.inviteCode }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="userName" label="账号" align="center">
                <template slot-scope="scope">
                  账号：<span>{{ scope.row.userName }}</span><br/>
                  密码：<span>{{ scope.row.password }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="total" label="数量" align="center">
                <template slot-scope="scope">
                  总数量：<span>{{ scope.row.total }}</span><br/>
                  已使用：<span>{{ scope.row.useNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="disabled" label="状态" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.disabled === 1 ? '禁用' : '启用' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="createDate"
                  label="创建时间"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      @click="handleEdit(scope.$index, scope.row)"
                  >编辑
                  </el-button
                  >
                  <el-button
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditGroupUser
            :editShow="editShow"
            :editData="editData"
            @backFunStu="getFunStu"
        ></EditGroupUser>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditGroupUser from "../../components/major/EditGroupUser";
import DeleteDialog from "../../components/public/DeleteConfim";

export default {
  data() {
    return {
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      searchForm: {
        name: "",
        phone: "",
        userName: "",
        disabled: "-1",
        registerId: "0",
        documentTypeId: "0",
        endDate: new Date(
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ),
        startDate: new Date(
            new Date(new Date().toLocaleDateString()).getTime() -
            (new Date(new Date().toLocaleDateString()).getTime() -
                new Date(new Date().getFullYear().toString()))
        ),
      },
      DocumentType: [],
      registers: [],
      groupUserId: "",
      action: localStorage.getItem("url"),
      editData: {},
      listShow: true,
      editShow: false,
      delVisible: false,
      dataList: [],
      multipleSelection: [],
      projectId: localStorage.getItem("project_Id"),
      groupUser_Id: "",
      url: localStorage.getItem("url").replace('/api', '/group_login?projectId=' + localStorage.getItem("project_Id")),
      url1: localStorage.getItem("url").replace('/api', '/group/' + localStorage.getItem("project_Id")),
    };
  },
  created() {
    this.getData();
    this.getDocumentType();
    this.load();
  },
  methods: {
    getDocumentType() {
      this.$axios
          .get("/DocumentType/Project/" + this.projectId)
          .then((res) => {
            if (res.data.hasError == false) {
              this.DocumentType = [...res.data.data];
            }
          });
    },
    uploadChange(file, fileList) {
      let inputDOM = this.$refs.inputer; // 通过DOM取文件数据

      this.file = event.currentTarget.files[0];
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;

      var reader = new FileReader(); //if (!FileReader.prototype.readAsBinaryString) {
      FileReader.prototype.readAsBinaryString = function (f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var wb; //读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              //手动转化
              type: "base64",
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary",
            });
          } // outdata就是你想要的东西 excel导入的数据
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); // excel 数据再处理
          let ar = [];
          outdata.map((v) => {
            let obj = {};
            obj.groupUserId = v.ID;
            obj.registerId = v.注册通道ID;
            obj.documentTypeId = v.证件类型ID;
            obj.name = v.团组名称;
            obj.userName = v.账号;
            obj.phone = v.手机号;
            obj.password = v.密码;
            obj.total = v.总数量;
            obj.disabled = v.禁用;
            obj.inviteCode = v.邀请码;
            obj.typeName = v.注册通道;
            ar.push(obj);
          });
          localStorage.setItem("attr", JSON.stringify(ar));
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },
    importData() {
      this.attr = JSON.parse(localStorage.getItem("attr"));
      if (this.attr && this.attr.length > 0) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.$axios
            .patch("/GroupUser/" + this.projectId, this.attr)
            .then((res) => {
              if (res.data.hasError == false) {
                loading.close();
                this.searchSubmit();
                localStorage.setItem("attr", null);
                this.$message.success(res.data.message);
              } else {
                this.$message.error(res.data.message);
                loading.close();
              }
            })
            .catch(function () {
              loading.close();
            });
      } else {
        this.$message.error("没有可上传的数据");
      }
    },
    importModifyData() {
      this.attr = JSON.parse(localStorage.getItem("attr"));
      if (this.attr && this.attr.length > 0) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.$axios
            .put("/batch/GroupUser/" + this.projectId, this.attr)
            .then((res) => {
              if (res.data.hasError == false) {
                loading.close();
                this.searchSubmit();
                localStorage.setItem("attr", null);
                this.$message.success(res.data.message);
              } else {
                this.$message.error(res.data.message);
                loading.close();
              }
            })
            .catch(function () {
              loading.close();
            });
      } else {
        this.$message.error("没有可上传的数据");
      }
    },
    exportExcel() {
      var search = {
        name: this.searchForm.name,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
        phone: this.searchForm.phone,
        userName: this.searchForm.userName,
        projectId: this.projectId,
        registerId: this.searchForm.registerId,
        documentTypeId: this.searchForm.documentTypeId,
        disabled: this.searchForm.disabled,
      };
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
          .post(`/GroupUser/Export`, search)
          .then((res) => {
            loading.close();
            if (res.data.data) {
               window.open(res.data.data, '_self');
              // this.$download(res.data.data, '导出证件.xlsx');
            } else {
              this.$message.error("导出不通过");
            }
          })
          .catch((a) => {
            loading.close();
            this.$message.error("导出不通过");
          });
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
    addSubmit() {
      this.groupUser_Id = "";
      this.editData = null;
      this.listShow = false;
      this.editShow = true;
    },
    searchSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    handleDelete(index, row) {
      this.groupUser_Id = row.groupUserId;
      this.delVisible = true;
    },
    handleCloseVisible() {
      this.groupUser_Id = "";
      this.delVisible = false;
    },
    download() {
      var url = localStorage.getItem("url");
      if (url.lastIndexOf("/api") == url.indexOf("/api")) {
        window.open(url.replace("/api", "/") + "/data/团组模板.xlsx");
      } else {
        window.open(
            url.substring(0, url.lastIndexOf("/api")) + "/data/团组模板.xlsx"
        );
      }
    },
    deleteData() {
      this.$axios.delete(`/GroupUser/${this.groupUser_Id}`).then((res) => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("删除成功！");
          this.delVisible = false;
          this.getData();
        }
      });
    },
    // 获取数据
    getData() {
      var search = {
        name: this.searchForm.name,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
        phone: this.searchForm.phone,
        userName: this.searchForm.userName,
        projectId: this.projectId,
        registerId: this.searchForm.registerId,
        documentTypeId: this.searchForm.documentTypeId,
        disabled: this.searchForm.disabled,
      };
      this.$axios.post("/GroupUser/Search", search).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    load() {
      this.$axios
          .get("/Register/Project/" + this.projectId)
          .then((res) => {
            if (res.data.hasError == false) {
              this.registers = [...res.data.data];
            } else {
              console.log(res.data.message);
            }
          })
          .catch(function () {
          });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
  },
  components: {
    EditGroupUser,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.table-wrap {
  margin-left: 10px;
  height: 100%;
}

.el-main {
  border-radius: 5px;
  position: relative;
}

.uers-left {
  float: left;
}

.uers-right {
  float: right;
}

.uers-import {
  margin-right: 30px;
  float: right;
  width: 240px;
}

.upload-excel {
  float: left;
}

.import-bnt {
  float: right;
}

.el-upload {
  height: 32px !important;
  line-height: 32px !important;
  width: 120px !important;
}

.el-upload--text {
  border: 0;
}

.file-up {
  width: 100px;
  position: absolute;
  height: 32px;
  opacity: 0;
}

.import-text {
  margin: 15px 0;
}

.el-upload--text {
  width: 110px;
  height: 32px;
  line-height: 32px;
  border: 0;
}

.down-template {
  position: absolute;
  top: 40px;
  right: 10px;
}
</style>